
import image from './123.png'
import Modal from '../Modal/Modal'

const Home = ()=> {
    return (
        <>
            <div className="w-screen h-screen bg-black">
                <img src={image} className='w-full h-full' alt="" />
                <Modal/>

            </div>
        </>
    )
}

export default Home